// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2laSr","label":"Section_label__7YAD5","contentWrap":"Section_contentWrap__2La7P","footer":"Section_footer__3eQ01","footerInner":"Section_footerInner__3tbEG"};